<template>
  <header
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="mom-page-header"
  >
    <div class="mom-page-header__main">
      <h1 class="mom-page-header__title">
        {{ $route.meta.pageTitle }}
      </h1>
      <nav
        v-if="$route.meta.breadcrumb"
        :aria-label="$t('foundation.breadcrumb')"
      >
        <b-breadcrumb>
          <b-breadcrumb-item to="/">
            <feather-icon
              icon="HomeIcon"
              size="16"
              class="align-text-top"
            />
            <span class="sr-only">{{ $t('foundation.home') }}</span>
          </b-breadcrumb-item>
          <b-breadcrumb-item
            v-for="item in $route.meta.breadcrumb"
            :key="item.text"
            :active="item.active"
            :to="item.to"
          >
            {{ item.text }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </nav>
    </div>
    <portal-target
      name="page-actions"
      tag="div"
      class="mom-page-header__actions"
    />
  </header>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
  },
}
</script>
